
<!--
 * @Description: 电子合同条目组件
--> 

<template>
	<div class="invoice-item">
		<div class="item-title">
			<!-- <van-checkbox :name="item.pid"
				checked-color="#1677FF"
				icon-size="16px"
				v-model="item.active"
				@click="changeCheck(item)">
				发起时间：{{item.createdate}}
			</van-checkbox> -->
			<div>发起时间：{{item.createdate}}</div>
			<div class="down">合同下载</div>
		</div>
		<div style="padding:10px">
			<div class="item-info">
				<span class="info-name">业务类型：</span>
				<span class="info-value">{{item.busstype}}</span>
			</div>
			<div class="item-info">
				<span class="info-name">合同类型：</span>
				<span class="info-value">{{item.contracttype}}</span>
			</div>
			<div class="item-info">
				<span class="info-name">签署时间：</span>
				<span class="info-value">{{item.finishdate}}</span>
			</div>
			<div class="item-info">
				<span class="info-name">签署状态：</span>
				<span class="info-value"
					style="color:#2C82C9;">
					{{item.statusname}}
				</span>
			</div>
			<div class="item-info">
				<span class="info-name">合同pdf：</span>
				<span v-if="item.url" class="info-value">
					<a :href="item.url">点击下载</a>
				</span>
				<span v-else class="info-value">
					无
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "InvoiceItem",
	components: {},
	props: {
		item: Object
	},
	data() {
		return {
			checked: false
		};
	},
	created() {
	},
	methods: {
		changeCheck(item) {
			this.$emit("changecheck", item);
		},
		urlClick(item){
			if(item.url){
				window.location.href = item.url;
			}else{
				this.$toast('无pdf地址')
			}
		}
	},
	watch: {
	}
};
</script>

<style lang="less" scoped>
.invoice-item {
	background: rgba(255, 255, 255, 1);
	.item-title {
		padding: 0 10px;
		height: 40px;
		border-bottom: 1px solid #EEEEEE;
		display: flex;
		align-items: center;
		font-size: 15px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		.down{
			color: #6096F8;
			font-weight: normal;
			text-align: right;
			flex: 1;
		}
	}
	.item-info {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		line-height: 1.8em;
		color: #333333;
		display: flex;
		.info-name {
			max-width: 76px;
		}
		.info-value {
			width: calc(~"100% - 76px");
		}
	}
}
</style>